/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CtiosRequestState = 'CREATED' | 'SUCCEEDED' | 'SUCCEEDED_WITH_ERRORS' | 'FAILED' | 'RESENT' | 'RESENT_AS_DUPLICATE' | 'RESEND_FAILED';

export const CtiosRequestState = {
    CREATED: 'CREATED' as CtiosRequestState,
    SUCCEEDED: 'SUCCEEDED' as CtiosRequestState,
    SUCCEEDED_WITH_ERRORS: 'SUCCEEDED_WITH_ERRORS' as CtiosRequestState,
    FAILED: 'FAILED' as CtiosRequestState,
    RESENT: 'RESENT' as CtiosRequestState,
    RESENT_AS_DUPLICATE: 'RESENT_AS_DUPLICATE' as CtiosRequestState,
    RESEND_FAILED: 'RESEND_FAILED' as CtiosRequestState
};

